<template>
<form autocomplete="off">
  <div class="md-autocomplete-loading" v-show="isPromisePending">
    <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
  </div>
  <CrudToolbar :save="saveCaseTemplate" :form="form" :$v="$v" :formConfig="formConfig" :cancel="cancel" :btnActive="btnActive"></CrudToolbar>

  <div class="md-layout">
    <grid-layout
        :layout.sync="formLayout"
        :col-num="12"
        :is-draggable="false"
        :is-resizable="false"
        :auto-size="false"
        :is-mirrored="false"
        :vertical-compact="true"
        :responsive="false"
        :margin="[10, 10]"
        :use-css-transforms="true"
      >
        <grid-item v-for="(slot, slotName, index) in formConfig.slots" :id="slotName"
                  :x="slot.layout.x"
                  :y="slot.layout.y"
                  :w="slot.layout.w"
                  :h="slot.layout.h"
                  :i="slot.layout.i"
                  :key="'griditem_'+ slotName + slot.layout.i"
        >

  <div v-if="slot.editModeOnly && formConfig.pageMode == 'new'" :key="slotName" class="vue-grid-item-content">
    <h3><span class="heading">{{slot.label}}</span></h3>Create a base record to enable this section.
  </div>
  <div v-else :key="slotName" class="vue-grid-item-content">
        
            <h3><span class="heading">{{slot.label}}</span></h3>
          
        <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">

          <CrudCheckbox
            v-if="field.type == 'checkbox'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudCheckbox>

          <CrudDatepicker
            v-else-if="field.type == 'datepicker'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudDatepicker>

          <CrudSelect
            v-else-if="field.type == 'select'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSelect>

          <CrudAutocomplete
            v-else-if="field.type == 'autocomplete'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudAutocomplete>

          <CrudJson
            v-else-if="field.type == 'json'" :key="name" class="field"
            :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudJson>

          <CrudSwitch
            v-else-if="field.type == 'switch'" :key="name" class="field"
            :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSwitch>


          <!--
          <CrudText
            v-else :key="name"
            :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.formConfig.fields" :field.sync="field"></CrudText>
            -->

          <CrudId
            v-else-if="field.type == 'id'" :key="name" class="field"
            :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudId>

          <CrudText
            v-else :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudText>

        </template>
        </div>
      
        <gridItemHook />
      </grid-item>
    </grid-layout>
  </div>
  <template>

    <div class="md-layout-item md-size-100 _taskLayoutCard" v-if="(formConfig.pageMode === 'view' || formConfig.pageMode === 'assignee') && recordData">
          <collapse class="collapse-head"
            :collapse="[
              'Tasks',
            ]"
            icon="keyboard_arrow_down"
            color-collapse="success _collapseFeed _collapseCaseFeed"
            :defaultActive="defaultActiveCollapseIndex"
            id="Tasks"
          >
            <template slot="md-collapse-pane-1">
              
              <CaseTemplateTaskViewComponent 
                :taskTemp="recordData ? recordData.tasks.items : []"
              />
            </template>
          </collapse>
          <br>
    </div>

    <CustomCaseTemplateTaskList v-if="formConfig.pageMode != 'view' && formConfig.pageMode !== 'assignee'"
      :list.sync="tasksList" 
      :filter="taskCaseIdFilter"
      :mode="formConfig.pageMode"
      :initGroups="groups" 
      @tasksChanged="onTasksChanged"
    ></CustomCaseTemplateTaskList>

  </template>
  
</form>
</template>

<script>
  import _ from "lodash";
  import RecordForm from '@/mixins/RecordForm';
  import VueGridLayout from 'vue-grid-layout';
  import { Collapse } from "@/components";
  import CaseTemplateTaskViewComponent from '@/components/DynamicForm/CaseTemplateTaskView/CaseTemplateTaskViewComponent';
  import CustomCaseTemplateTaskList from "@/components/DynamicForm/CustomCaseTemplateTaskList";
  
  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as mutations from '@/graphql/mutations';

  const gridItemHook = {
    mounted(){
      // [i] This pushes each gridItem into this.gridItems below for config-form
      this.$parent.$parent.$parent.gridItems.push(this.$parent);
    },
    render(h){
      return h('div', [h('div',{attrs: {contentEditable: true, class: 'editable'}})])
    }
  };

  export default {
    name: "config-form",
    mixins: [RecordForm],
    components: {
      Collapse,
      CaseTemplateTaskViewComponent,
      CustomCaseTemplateTaskList,
      GridLayout: VueGridLayout.GridLayout,
      GridItem: VueGridLayout.GridItem,
      gridItemHook
    },
    computed: {
      taskCaseIdFilter: function () { return {"taskCaseId": {"eq": this.$route.params.id }}; }
    },
    data() {
      return {
        formLayout: [//default value so that at least it works
          {"x":0,"y":0,"w":2,"h":2,"i":"0"},
          {"x":2,"y":0,"w":2,"h":4,"i":"1"},
          {"x":4,"y":0,"w":2,"h":5,"i":"2"},
          {"x":6,"y":0,"w":2,"h":3,"i":"3"},
          {"x":8,"y":0,"w":2,"h":3,"i":"4"},
          {"x":10,"y":0,"w":2,"h":3,"i":"5"},
          {"x":0,"y":5,"w":2,"h":5,"i":"6"},
          {"x":2,"y":5,"w":2,"h":5,"i":"7"},
          {"x":4,"y":5,"w":2,"h":5,"i":"8"},
          {"x":6,"y":4,"w":2,"h":4,"i":"9"},
          {"x":8,"y":4,"w":2,"h":4,"i":"10"},
          {"x":10,"y":4,"w":2,"h":4,"i":"11"},
          {"x":0,"y":10,"w":2,"h":5,"i":"12"},
          {"x":2,"y":10,"w":2,"h":5,"i":"13"},
          {"x":4,"y":8,"w":2,"h":4,"i":"14"},
          {"x":6,"y":8,"w":2,"h":4,"i":"15"},
          {"x":8,"y":10,"w":2,"h":5,"i":"16"},
          {"x":10,"y":4,"w":2,"h":2,"i":"17"},
          {"x":0,"y":9,"w":2,"h":3,"i":"18"},
          {"x":2,"y":6,"w":2,"h":2,"i":"19"}
        ],
        gridItems: [],
        btnActive: false,
        defaultActiveCollapseIndex: 1,
        groups: [],
        tasks: [],
        tasksList: {
          hasUpdatedBy: true,
          updatedByTaskFieldName: 'taskUpdatedById',
          updatedByTaskStepFieldName: 'taskStepUpdatedById',
          showRelatedDialog: false,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "input",
              click: "handleRedirect"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "tasktemplates",
          pageTitle: "Add Tasks",
          pageIcon: "assignment_ind",
          listQueryId: "searchTasks",
          deleteQueryId: "deleteTask",
          //deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to delete {objectName}?",
          deleteMessageText: "",
          deleteMessageNameFields: ['subject'],
          columns: {
            group: { label: "Group" },
            subject: { label: "Task", sortable: true },
            status: { label: "Status", sortable: true },
            user: { label: "Assignee", sortable: true },
            dateDue: { label: "dateDue", sortable: true },
          },
          fuseSearch: null,
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
          },
          tableData: [],
          searchedData: [],
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchTasks && data.searchTasks.items.length) {
              result = data.searchTasks.items;
            }
            return result;
          },
        }
      }
    },
    beforeMount() {
      let layout = [];
      this.$loopo(this.formConfig.slots, (slot) => {
        layout.push(slot.layout);
      });
      if (layout.length) {
        this.formLayout = layout;
      }
    },
    updated() {
      this.gridItems.forEach(gridItem => {
        gridItem.autoSize();
      });
    },
    watch: {
      recordData: {
        handler: function(newVal, oldVal) {
          if (newVal && newVal.tasks && newVal.tasks.items)
            this.buildGroups(newVal.tasks.items)
        },
        immediate: true        
      },   
    },
    methods: {
      orderedTasks: function (tasks) {
        return _.orderBy(tasks, 'order');
      },
      buildGroups(payload) {
        console.log(payload);
        const groups = [];
        payload.map((_item) => {
          if (undefined === _item.group || null === _item.group) {
            return;
          }
          if (!groups[_item.group]) {
            groups[_item.group] = [];
          }
          groups[_item.group].push(_item);
        });
        console.log(groups);
        this.groups = [];
        groups.map(_group => {
          if (_group.length) {
            this.groups.push(_group);
          }
        });
        if (!this.groups.length) {
          this.groups.push([]);
        }
        console.log(this.groups);
      },
      onTasksChanged(tasks) {
        this.tasks = tasks;
        this.btnActive = true;
      },
      async saveCaseTemplate() {
        this.isPromisePending = true;
        this.$v.$touch();
        if(this.$v.$invalid) {
            this.$c.log('save(): unable to save, $v.invalid');
            return;
        }
        let data = {};
        const form = this.form;
        const fields = this.formConfig.fields;
        this.$loopo(fields, (field, name) => {
          if (!field.fields) {
            if (typeof form[name] !== 'undefined' && form[name] !== null) {
              if (field.type === 'datepicker') {
                try{
                  data[name] = form[name].toUTCString();
                }catch (e) {
                  data[name] = form[name].toString();
                  console.log('datepicker try catch ',form[name])
                }
              } else {
                data[name] = form[name];
              }
            }
          } else {
            if (field.type === 'json') {
              data[name] = JSON.stringify(form[name].fields);
            }
          }
        });
        // We should not send any empty strings on create
        if (this.formConfig.pageMode == 'new') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                delete data[name];
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  delete data[name];
                }
              }
            }
          });
        }
        if (this.formConfig.pageMode == 'edit') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                data[name] = null;
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  data[name] = null;
                }
              }
            }
          });
        }
      
        /**
         * ATLAS-877 - Add Updatedby to all Models in the Schema
         * @see https://zeamster.atlassian.net/browse/ATLAS-877
         */
        const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByFieldName');
        if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
          data[updatedByFieldName] = this.$reduce(this, '$Session.userId');
        }
        
        await this.createCaseTemplate(data);
      },
      async createCaseTemplate(data) {        
        this.isPromisePending = true;
        let query = this.getMutation(this.formConfig.pageMode === 'edit'? this.formConfig.actions.update : this.formConfig.actions.save);
        const result = await API.graphql(graphqlOperation(query, {input: data}))
        .then(result => {
          let responseKey = (this.formConfig.pageMode === 'new'? 'create' : 'update') + this.formConfig.objectName;
          let responseId = result.data[responseKey].id
          this.$c.log("success! responseKey = " + responseKey);
          this.$c.log("success! responseId = " + responseId);
          this.isPromisePending = false;

          let promiseArr = [];

          let taskArr = [];
          this.tasks.forEach((_element, _elementIndex) => {
            _element.items.forEach((_itemElement, _itemIndex) => {
              taskArr.push(_itemElement)  
            });
          });
          console.log(taskArr);
          let recordArr = [];
          if(this.recordData && this.recordData.tasks && this.recordData.tasks.items) {
            recordArr = JSON.parse(JSON.stringify(this.recordData.tasks.items));
          }       
          console.log(recordArr);
          
          recordArr.forEach((_recordElement, _recordIndex) => {
            
            let indexFound = _.findIndex(taskArr, {
              id: _recordElement.id
            });
            if (indexFound == -1)
            {
              console.log("Delete",_recordElement);
              let deleteTaskData = {
                id: _recordElement.id,
                taskCaseTemplateId: null
              };
              
              /**
               * ATLAS-877 - Add Updatedby to all Models in the Schema
               * @see https://zeamster.atlassian.net/browse/ATLAS-877
               */
              const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskFieldName');
              if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
                deleteTaskData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
              }
              
              let gqlRequest = API.graphql(graphqlOperation(mutations['updateTask'], {input: deleteTaskData}));
              promiseArr.push(gqlRequest);
            }          
          });       
          
          
          if(this.tasks.length) {
            this.isPromisePending = true;
            let promiseArr = [];  
            this.tasks.forEach((_element, _elementIndex) => {
              _element.items.forEach((_itemElement, _itemIndex) => {
                let caseTemplateTaskData = {
                  id: _itemElement.id,
                  order: _itemIndex + 1,
                  group: _elementIndex + 1,
                  taskCaseTemplateId: responseId
                }
                
                /**
                 * ATLAS-877 - Add Updatedby to all Models in the Schema
                 * @see https://zeamster.atlassian.net/browse/ATLAS-877
                 */
                const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskFieldName');
                if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
                  caseTemplateTaskData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
                }
                
                let gqlRequest = API.graphql(graphqlOperation(mutations['updateTask'], {input: caseTemplateTaskData}));
                promiseArr.push(gqlRequest);
              });
            });
            console.log(promiseArr);
            Promise.all(promiseArr).then((resultPromise) => {
              this.isPromisePending = false;
              this.$c.log('Case Template Tasks Updated Successfully');
              this.isDisabled = true;
              this.$router.push(this.formConfig.listPath + '/' + responseId);
              this.loadData(result.data[responseKey]);  
            });  
          } else {
            this.$router.push(this.formConfig.listPath + '/' + responseId);
            this.loadData(result.data[responseKey]);
          }

          
        })
        .catch(error => {
          this.$c.log(error);
          this.isPromisePending = false;
        });
      }
    }
  };
</script>

<style lang="scss">
  .crud-toolbar {
    .md-button {
      margin-top: .3125rem !important;
    }
    .md-card .md-card-header.md-card-header-icon i {
      margin-top: -8px;
    }
  }
  input.is-danger {
    border: 2px solid red;
  }

  .md-content.md-theme-default.md-tabs-content {
    background-color: transparent !important;
    height: auto !important;
  }

  form {
    .md-field.md-autocomplete {
      .md-input-action.md-button.md-clear {
        width: 20px;
        height: 20px;
        min-width: 20px;
        right: 25px;
        top: 5px;
      }
    }

    fieldset {
      border: none;
      padding: 0;
      width: 100%;
      margin: 0;

      legend {
        margin-bottom: 0;
        width: 100%;
        padding-left: 0;
        margin-left: 0;

        h5 {
          margin-bottom: 0;
        }
      }
    }
  }

 .md-tab .md-layout .md-card.md-theme-default {
    margin-bottom: 0;
    margin-top: 15px;
  }
</style>
